import { returnFormattedDate } from "@/lib/globalFormatterHelper";

/**
 * Format settlement date value for display.
 */
export function formatSettlementDate(value: any): string {
  if (!value) return "";
  return returnFormattedDate(value);
}

/**
 * AG Grid valueFormatter for copy/paste.
 * Returns formatted date with trailing space per project convention.
 */
export function settlementDateValueFormatter(params: any): string {
  if (!params.value) return "";
  return `${returnFormattedDate(params.value)} `;
}
